// LINK HANDLER
function linkHandler(element, event) {

    var $link = element;
    var url = ($link.attr('href') || $link.attr('data-link'));


    if ($link.hasClass('no-link') || url.match('^#')) {
        return;
    }
    if (event.ctrlKey || event.shiftKey || event.metaKey || (event.button && event.button === 1)) {
        window.open(url, "_blank");
        return;
    }

    if ($link.attr('target') === "_blank") {
        window.open(url, "_blank");
        return;
    }

    if (url === window.location.href) {
        return;
    }

    if (event && $(event.target).closest('.no-link').length) {
        return;
    }

    // Ou on joue une simple redirection
    window.location.href = url;
}

function initLinks() {
    $(document).on('click', '[data-link]', function (event) {
        linkHandler($(this), event);
        $(this).find('a').click(function (e) {
            e.stopPropagation();
        });
    });

    $(document).on('click', '.scroll-to-top', function (e) {
        window.scrollTo({top: 0, behavior: 'smooth'});
    });

    $(document).on('click', 'a', function (e) {
        e.preventDefault();
        linkHandler($(this), e);
    });
}
